import React from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import Layout from '../Layout'
import Container from '../Container'
import SEO from '../components/SEO'
import Title from '../components/ArticleTitle'
import Sidebar from '../components/ArticleSidebar'
import Content from '../components/ArticleContent'
import ArticleGrid from '../components/ArticleGrid'
import StaticSignUpBanner from '../components/StaticSignUpBanner'

const ArticleTemplate = ({ location, data, pageContext }) => {
  const {
    title,
    categories,
    slug,
    body,
    publishDate,
    featuredImage,
  } = data.contentfulArticle

  const articleNode = data.contentfulArticle
  const relatedArticles = pageContext.relatedArticles

  return (
    <Layout>
      <SEO pagePath={slug} postNode={articleNode} postSEO />

      <main className="main-content">
        <h1 className="sr-only">{title}</h1>
        <Container flex>
          <Title
            title={title}
            category={categories}
          />
          <Sidebar
            publishDate={publishDate}
            pageURL={location.href}
          />
          <Content
            content={body}
            featuredImage={featuredImage}
            relatedArticles={relatedArticles}
            pageURL={location.href}
          />
          <div className="relatedArticlesContainer">
            { relatedArticles.map(singleArticle => {
              const { slug, title, publishDate, body, categories, featuredImage } = singleArticle.node
              return (
                <ArticleGrid
                  key={slug}
                  slug={slug}
                  title={title}
                  publishDate={publishDate}
                  body={body}
                  categories={categories}
                  featuredImage={featuredImage}
                />
              )
            })
            }
          </div>
        </Container>
        <StaticSignUpBanner />
      </main>
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    contentfulArticle(slug: { eq: $slug }) {
      title
      slug
      metaDescription {
        internal {
          content
        }
      }
      publishDate(formatString: "YYYY/MM/DD")
      publishDateISO: publishDate(formatString: "YYYY-MM-DD")
      tags {
        title
        id
        slug
      }
      categories {
        title
      }
      featuredImage {
        ...FluidImageFragment
        imageFile {
          ogimg: resize(width: 1200) {
            src
            width
            height
          }
        }
      }
      body {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`

ArticleTemplate.propTypes = {
  data: PropTypes.shape({
    contentfulPost: PropTypes.shape({
      featuredImage: PropTypes.object,
      publishDate: PropTypes.string,
      tags: PropTypes.array,
      categories: PropTypes.shape({
        title: PropTypes.string.isRequired,
      }).isRequired,
      title: PropTypes.string,
      slug: PropTypes.string,
      body: PropTypes.shape({
        childMarkdownRemark: PropTypes.shape({
          html: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,

  pageContext: PropTypes.shape({
    prev: PropTypes.object,
    next: PropTypes.object,
  }).isRequired,

  location: PropTypes.shape({
    href: PropTypes.string,
  }).isRequired,
}

export default ArticleTemplate
